import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store, { State, $s } from './store'
import Vuetify from 'vuetify'
import { api } from './singleton'
import i18n from '@/i18n'
import {deepCopy, magicCode2Text, getDevSeries} from '@/utils'
import moment from 'moment'
import { language_t } from '@/store/modules/pref'
import axios from 'axios'
import VeeValidate from 'vee-validate'

// @ts-ignore
import vvMsgEn from 'vee-validate/dist/locale/en'
// @ts-ignore
import vvMsgJa from 'vee-validate/dist/locale/ja'
// @ts-ignore
import vvMsgZh from 'vee-validate/dist/locale/zh_TW'

import {polyfill as dndPolyfill} from 'mobile-drag-drop'
import { IDevice } from '@/types/model'
import { ApiCurrentUser, extender_vendor_t } from '@/types/api'
import easyapi from '@/easyapi'
dndPolyfill()
// ======================================================
// this.ppp() for debug
// ======================================================
Vue.mixin({
  methods: {
    ppp (...args: any[]) {
      const fname = this.$options['__filename']
      console.log(fname, ...args.map((x) => typeof x === 'object' ? deepCopy(x) : x))
    },
    /** Device Name */
    dn (dev: IDevice) {
      const prefix = getDevSeries(dev.vendor)
      if (!dev.mac) { return `(${this.$t('term.untitled')}) ${prefix}_?` }
      return dev.deviceName ? dev.deviceName : `(${this.$t('term.untitled')}) ${prefix}_${dev.mac.replace(/:/g, '').slice(8)}`
    },
  },
  computed: {
    mc (): magicCode2Text {
      return magicCode2Text
    }
  }
})

window['VERSION'] = {
  UI: '0.0.2 (2019-01-22)',
  VUETIFY: Vuetify.version
}

// ======================================================
// Make Typed vuex state for Vue instance
// ======================================================
declare module 'vue/types/vue' {  // IntelliSense for vm.$state (Vue instance getter)
  interface Vue {
    $state: State
    $s: typeof $s  // This is so ridiculous
    dn: (dev: IDevice) => string
  }
}
const TypedState = {
  // tslint:disable-next-line:no-shadowed-variable
  install (Vue: any) {
    Object.defineProperty(Vue.prototype, '$state', {
      get (): State { return store.state as State }
    })
    Object.defineProperty(Vue.prototype, '$s', {
      get () { return $s }
    })
  }
}
Vue.use(TypedState)

// ======================================================
// Vuetify
// ======================================================
Vue.use(Vuetify, {
  theme: {
    primary: '#D6314B',
    secondary: '#D6314B',
    accent: '#D6314B',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
  },
})

// ======================================================
// Vee-Validate
// ======================================================
Vue.use(VeeValidate, {
  dictionary: {
    en: vvMsgEn,
    ja: vvMsgJa,
    zh: vvMsgZh,
  }
})

// ======================================================
// WTF
// ======================================================
Vue.config.productionTip = false   // FIXME: What is this?

// ======================================================
// Authentication (Login/Logout) & Router
// ======================================================
function setupAuthRouterHook () {
  router.beforeEach((to, from, next) => {
    console.log('afterEach', to)
    if (store.state.auth.isLoggedIn) {
      if (to.name === 'login') {
        return next({ path: from.path })
      }
    } else {
      if (to.name !== 'login') {
        return next({ name: 'login' })
      }
    }
    if (
      to.name === 'vwlst_details' &&
      from.name &&
      // from.name.includes(to.name) &&
      (from.name === 'vwlst_details_rxmap' || from.name === 'vwlst_details_txmap')
    ) {
        easyapi.vwPreviewRestore()
    }
    return next()
  })
}
router.afterEach((to, from) => {
  // console.log('[ROUTER] to ==>', to)
})
// TODO: 監聽 RequestManager的事件。eventName ::= loggedIn | loggedOut
api.reqMan.on('currentUserGotten', (user: ApiCurrentUser | null) => {
  console.log('[main] currentUserGotten ===>', user)
  if (!user) {
    router.replace({ name: 'login' })
  } else if (user.account !== '') {
    easyapi.loadCurrentUserPreference()
    $s.auth.mutations.assignLoginState(user)
    if (router.currentRoute.name === 'login') {
      router.replace({ name: 'home' })
    }
  } else {
    router.replace({ name: 'login' })
  }
  setupAuthRouterHook()
})

api.reqMan.on('loggedOut', () => {
  console.log('[main] loggedOut')
  $s.auth.mutations.assignLoginState(null)
  $s.common.mutations.assignNetworkError(false)
  router.replace({ name: 'login' })
})

// ======================================================
// Filters
// ======================================================
const filters = {
  durSecToHuman (durSec: number): string {
    return moment.duration(durSec, 'seconds').humanize(durSec < 0)
  }
}
for (const filterName of Object.keys(filters)) {
  Vue.filter(filterName, filters[filterName])
}
declare module 'vue/types/vue' {  // IntelliSense for vm.$filters
  interface Vue {
    $filters: typeof filters
  }
}
const TypedFilters = {
  // tslint:disable-next-line:no-shadowed-variable
  install (Vue: any) {
    Object.defineProperty(Vue.prototype, '$filters', {
      get (): typeof filters { return filters }
    })
  }
}
Vue.use(TypedFilters)

Vue.filter('mac', function (str: string): string {
  if (!str.includes(':')) {
    const arr: string[] = []
    for (let i = 0; i < str.length; i += 2) {
      arr.push(str.substr(i, 2))
    }
    str = arr.join(':')
  }
  return str.toUpperCase()
})

// ======================================================
// __main__
// ======================================================
const vue = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

